import React, {useEffect} from 'react'
import GenericModal from './generic-modal'
import {FormattedMessage} from 'react-intl'
import {Button, Flex, useDisclosure} from '@salesforce/retail-react-app/app/components/shared/ui'
import {remCalc} from '../../theme/_utils'

const DoiModal = () => {
    const disclosure = useDisclosure()

    useEffect(() => {
        window.DOI = {
            EVE: {
                emit: (e) => {
                    if (e === 'EVENTS.GIGYA.DOI.MODAL') {
                        disclosure.onOpen()
                    }
                },
            },
        }
        return () => {
            delete window.DOI
        }
    }, [])

    return (
        <GenericModal {...disclosure}>
            <Flex direction="column" gap={remCalc(16)} p={remCalc(24)}>
                <FormattedMessage
                    defaultMessage="Just one more click: Please check your inbox and confirm your registration."
                    id="global.doi.one_more_click"
                />
                <Button variant="primary" onClick={disclosure.onClose}>
                    <FormattedMessage defaultMessage="Ok." id="global.doi.ok" />
                </Button>
            </Flex>
        </GenericModal>
    )
}

export default DoiModal
